<template>
    <div class="zui-spinner-triple-bounce-box" :style="style">
        <div class="zui-spinner-triple-bounce" >
            <div class="zui-spinner-triple-bounce-bounce1" :style="bounceStyle"></div>
            <div class="zui-spinner-triple-bounce-bounce2" :style="bounceStyle"></div>
            <div class="zui-spinner-triple-bounce-bounce3" :style="bounceStyle"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tripleBounce",
    props: {
        backgroundColor: {
            type: String,
            default: "transparent"
        },
        color: {
            type: String,
            default: "#ccc"
        },
        size: {
            type: String,
            default: "100%"
        },
        dotSize: {
            type: String,
            default: ""
        }
    },

    data() {
        let { color, backgroundColor, size, dotSize } = this;
        let style = {
            width: size,
            height: size,
            backgroundColor: backgroundColor
        };
        let bounceStyle = {
            backgroundColor: color
        };
        if (dotSize.length > 0) {
            bounceStyle = { ...bounceStyle, width: dotSize, height: dotSize };
        }
        return {
            style,
            bounceStyle
        };
    },
    methods: {}
};
</script>

<style scoped lang="scss">
.zui-spinner-triple-bounce-box {
    position: relative;
}

.zui-spinner-triple-bounce {
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 0;
    top: 0;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;

    .zui-spinner-triple-bounce-bounce1,
    .zui-spinner-triple-bounce-bounce2,
    .zui-spinner-triple-bounce-bounce3 {
        border-radius: 50%;
        display: inline-block;
        animation: zui-spinner-triple-bounce 1.4s infinite ease-in-out both;
        width: 0.2rem;
        height: 0.2rem;
    }

    .zui-spinner-triple-bounce-bounce1 {
        animation-delay: -0.32s;
        left: 25%;
    }

    .zui-spinner-triple-bounce-bounce2 {
        animation-delay: -0.16s;
        left: 50%;
    }
}

@keyframes zui-spinner-triple-bounce {
    0%,
    80%,
    100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1.2);
    }
}
</style>
